import * as React from 'react';
export const fnbtSvg = React.forwardRef(function fnbtSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F8FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      null,
      /*#__PURE__*/ React.createElement('rect', {
        x: -292,
        y: -1504,
        width: 665,
        height: 2398,
        rx: 4,
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        null,
        /*#__PURE__*/ React.createElement('path', {
          fill: '#003B7A',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M11 5a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h12.082v-3.207H11.977v-3.536h2.88l-.032-8.096c-.432.664-1.785 1.16-2.88 1.056v-3.072c1.656.265 3.52-.927 4.031-1.952h3.865v12.064h3.241V5H11Z',
          fill: '#FEFEFE',
        }),
      ),
    ),
  );
});
fnbtSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fnbt = {
  category: 'brand',
  colorable: false,
  name: 'fnbt',
  svg: fnbtSvg,
};
